import { FLOWCODE_API_ENDPOINT } from '@dtx-company/true-common/src/constants/endpoints'
import { createApi } from '@reduxjs/toolkit/query/react'
import { graphqlRequestBaseQuery } from '../../../redux/slices/flowpageApiSlice/utils'

const url = `${FLOWCODE_API_ENDPOINT}/design-templates/v1/graphql`

export const printStoreApi = createApi({
  reducerPath: 'printStoreApi',
  baseQuery: graphqlRequestBaseQuery({
    options: { url }
  }),
  tagTypes: [
    'printStoreBrandKit',
    'printStoreTemplates',
    'printStoreTemplateDetails',
    'printStoreCategories',
    'printStoreImageUrl'
  ],
  endpoints: () => ({})
})
